<template>
  <tooltip v-if="hasPermission(permission)" :label="tooltip" type="small" placement="top">
    <router-link :to="to" tag="button" class="button is-primary">
      <span class="icon">
        <i class="fa fa-plus"></i>
      </span>
    </router-link>
  </tooltip>
</template>

<script>
  import mixin from 'components/mixin';

  export default {
    mixins: [mixin],
    name: "add-button",
    props: {
      to: [Object, String],
      tooltip: String,
      permission: Array
    }
  }
</script>

<style scoped>

</style>